export const routePaths: Record<string, string> = {
  home: '/',
  assets: '/assets',
  account: '/account',
  assetsAll: '/assets/all',
  assetsMyVehicles: '/assets/my',
  assetsBridged: '/assets/bridged',
  assetsPortableUnits: '/assets/ptu',
  assetsShared: '/assets/shared',
  share: '/share',
  shareActive: '/share/active',
  shareActiveAll: '/share/active?filter=all',
  shareActiveInbound: '/share/active?filter=borrowed',
  shareActiveOutbound: '/share/active?filter=lent',
  shareActiveOnward: '/share/active?filter=onward',
  shareArchive: '/share/history',
  executionBoard: '/execution-board',
  executionBoardAll: '/execution-board/all',
  executionBoardPending: '/execution-board/pending',
  executionBoardCompleted: '/execution-board/completed',
  executionBoardOverdue: '/execution-board/overdue',
  executionBoardTable: '/execution-board/[table]',
  mapOverview: '/map',
  reportOverview: '/reports',
  reportDownloads: '/reports/downloads',
  contacts: '/contacts',
  login: '/login',
  forgotPassword: '/password/forgot',
  resetPassword: '/password/reset/[uid]/[token]',
  error: '/404',
  expiredUrl: '/expired-url',
  locations: '/locations',
} as const

export const unRestrictedRoutes = [
  routePaths.login,
  routePaths.forgotPassword,
  routePaths.resetPassword,
  routePaths.error,
  routePaths.expiredUrl,
] as const
